
import Component from "vue-class-component";
import { Mixins } from "vue-property-decorator";
import { FormatStructureEditor } from "../../../domain/editableFormat";
import { AsyncUtility } from "../../../../base/utilities";
import { IConfiguration } from "../../../domain/configuration";
import { MessageBroadcaster } from "../../../../base/components/system/utilities";
import { ModalPresentableMixin } from "../../../../base/components/system";

@Component
export default class FormatEditViewMixin extends Mixins(ModalPresentableMixin) {
  data(): any {
    return {
      model: null as FormatStructureEditor,
      isEditing: true,
      isWindowClosing: false,
      isLoading: false,
    };
  }
  model: FormatStructureEditor;
  isEditing: boolean;
  isWindowClosing: boolean;
  isLoading: boolean;

  $configuration!: IConfiguration;

  mounted() {
    // ページ遷移時に確認ダイアログを表示する.(文言は反映されないブラウザあり.)
    window.onbeforeunload = () => {
      if (!this.model) { return; }
      console.warn("編集中にページ遷移しようとしてるようです。");
      return "編集中の文書を破棄してもよろしいですか？";
    };
    this.$registerCloseConfirmation(this.closeConfirmation);
  }

  private async closeConfirmation(): Promise<boolean> {
    try {
      if (!this.model) { return true; }
      this.beginModal();
      const index = await this.$commonDialogs.confirmation.confirmDestructCancel(
        "確認",
        ["編集中の文書を破棄してもよろしいですか？"]
      );
      return (index === 0);
    } catch (e) {
      return false;
    } finally {
      this.endModal();
    }
  }

  async finishEditing(id: number, destinationRoute: any, isTemporary: boolean, archiveId: number): Promise<void> {
    this.isEditing = false;
    this.notifyMessage("finishEditing");
    if (await this.closeWindowIfNeeded(isTemporary)) { return; }
    if (destinationRoute !== null) {
      const route = destinationRoute
        ? destinationRoute
        : {
          path: "ShowFormat",
          query: {
            formatId: id,
            archiveId: archiveId,
            shouldNotifyRegistered: true.toString(),
            isTemporary: isTemporary.toString(),
          }
        };
      this.$router.replace(route);
    }
  }

  private notifyMessage(key: string): void {
    try {
      const message = this.createPostMessage(key);
      if (!!window.opener) {
        (window.opener as Window).postMessage(message, "*");
      } else if (this.$configuration.behavior.localhost.window.opener.isEnable) {
        MessageBroadcaster.sendTo("ShowFormatList", message);
      }
    } catch (e) {
      console.log(e);
    }
  }

  private createPostMessage(key: string): string {
    const message = {
      key,
    };
    return JSON.stringify(message);
  }

  async closeWindowIfNeeded(isTemporary: boolean): Promise<boolean> {
    const beginTimeAsMsec = (new Date()).getTime();
    const configuration = this.$configuration.formatEditor.behavior.format.editor.registerer.instantCloser;
    if (!configuration.isEnable) { return false; }
    // 参照画面を表示しない設定の場合はここで登録完了通知を出す
    this.isWindowClosing = true;
    const action = isTemporary ? "一時保存" : "登録";
    this.$successAsHTML(
      action + "完了",
      "<div>" + this.$wording.format.name + "を" + action + "しました。</div>"
    );
    // 追加の通知を行う設定の場合は通知を出す.
    if (configuration.notification.isEnable) {
      await AsyncUtility.sleep(configuration.notification.delayAsMsec); // IEで直前の$success()と被ってしまう事があるので待つ.
      this.$info("画面自動クローズ", configuration.notification.message.replace("$WAITTIMEASSEC$", Math.round(configuration.waitTimeAsMsec / 1000).toString()));
    }
    // 設定されている時間待つ
    const elapsedTimeAsMsec = (new Date()).getTime() - beginTimeAsMsec;

    if (elapsedTimeAsMsec < configuration.waitTimeAsMsec) {
      await AsyncUtility.sleep(configuration.waitTimeAsMsec);
    }
    this.$closeWindow(true);
    return true;
  }
}
